/**
 * ZENTRA brand logo — renders the official Valmay artwork.
 *
 * variant: "light" (white logo, for dark bg) | "dark" (black logo, for light bg)
 * size: "sm" | "md" | "lg"
 * layout: "stacked" (mark + ZENTRA + by Valmay Group, full lockup) | "mark" (Z mark only) | "horizontal"
 */
export default function ZentraLogo({ variant = "dark", size = "md", layout = "stacked" }) {
    const src =
        layout === "mark"
            ? variant === "light"
                ? "/brand/zentra-mark-light.png"
                : "/brand/zentra-mark-dark.png"
            : variant === "light"
              ? "/brand/zentra-logo-light.png"
              : "/brand/zentra-logo-dark.png";

    if (layout === "horizontal") {
        // Mark + text typeset to the right, for compact horizontal placement (e.g. topbar)
        const markPx = { sm: 26, md: 32, lg: 40 }[size];
        const wordCls = { sm: "text-base", md: "text-lg", lg: "text-2xl" }[size];
        const sigCls = { sm: "text-[9px]", md: "text-[10px]", lg: "text-xs" }[size];
        const wordColor = variant === "light" ? "text-white" : "text-zentra-primary";
        const sigColor = variant === "light" ? "text-zentra-accent/80" : "text-zentra-olive";
        return (
            <div className="flex items-center gap-2.5" data-testid="zentra-logo-horizontal">
                <img
                    src={
                        variant === "light"
                            ? "/brand/zentra-mark-light.png"
                            : "/brand/zentra-mark-dark.png"
                    }
                    alt=""
                    style={{ width: markPx, height: markPx, display: "block" }}
                />
                <div className="flex flex-col leading-none">
                    <span
                        className={`font-display font-bold tracking-tight ${wordCls} ${wordColor}`}
                        style={{ letterSpacing: "0.04em" }}
                    >
                        ZENTRA
                    </span>
                    <span
                        className={`font-sans font-medium tracking-[0.18em] uppercase mt-1 ${sigCls} ${sigColor}`}
                    >
                        by Valmay Group
                    </span>
                </div>
            </div>
        );
    }

    const widths = { sm: 96, md: 150, lg: 240 };
    const markWidths = { sm: 36, md: 52, lg: 80 };
    const w = layout === "mark" ? markWidths[size] : widths[size];

    if (layout === "mark") {
        return (
            <img
                src={src}
                alt="ZENTRA"
                style={{ width: w, height: w, display: "block" }}
                data-testid="zentra-logo-mark"
            />
        );
    }

    return (
        <img
            src={src}
            alt="ZENTRA by Valmay Group"
            width={w}
            style={{ display: "block", height: "auto" }}
            data-testid="zentra-logo"
        />
    );
}
